module.exports = __webpack_public_path__ + "img/xuchang1.5a29b6bc.png";